;(function () {
    "use strict";

    $(document).ready(function() {

        var $loadMore = $('.load-more');

        $loadMore.each(function() {
            var $instance = $(this);
            var $wrapper = $instance.find('.load-more__item').last().parent();
            var $odd = $instance.find('.load-more__odd');
            var $even = $instance.find('.load-more__even');
            var $button = $instance.find('.load-more__button');
            var $spinner = $instance.find('.load-more__spinner');
            var url = $instance.data().loadMoreUrl;
            var pager = $instance.data().loadMorePager;
            var currentPage = $instance.data().loadMoreCurrentPage || 1;

            function toggleButtonState (active) {
                typeof active == 'undefined' ? active = $button.hasClass('button_active') : active = active;

                if (active) {
                    $button.addClass('button_active').attr('disabled', true);
                    $spinner.show();
                }
                else {
                    $button.removeClass('button_active').removeAttr('disabled');
                    $spinner.hide();
                }
            }

            function hideButton () {
                $button.remove();
            }

            if (Boolean(url)) {

                $button.on('click', function() {
                    toggleButtonState(true);

                    var requestUrl = url;
                    if (Boolean(pager)) {
                        requestUrl += pager.replace('<%page%>', currentPage + 1);
                    }

                    $.get(requestUrl)
                        .always(function () {
                            toggleButtonState(false);
                        })
                        .fail(function(data) {
                            Toasts.pushToast(data.error || data.errors[0] || 'Что-то пошло не так, попробуйте позже', 'fail');
                        })
                        .complete(function(data) {
                            currentPage += 1;

                            var $items = $(data.responseText).filter(function() {
                                return $(this).is('.load-more__item');
                            });

                            if ($items.length < 1) {
                                hideButton();
                            }
                            else {
                                $items.each(function(index, value) {
                                    var $item = $(this);

                                    $item.addClass('slideable-new');

                                    if ($odd.length > 0 && $even.length > 0) {
                                        if (Boolean((index + 1) % 2)) {
                                            $item.appendTo($odd);
                                        }
                                        else {
                                            $item.appendTo($even);
                                        }
                                    }
                                    else {
                                        $item.appendTo($wrapper);
                                    }

                                    _.defer(function(){
                                        $(document).trigger('Reviews::newItemsAdded');
                                    });
                                });
                            }
                        });
                });
            }
            else {
                hideButton();
            }
        });
    });
})();